import { Radio } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'

import { HeaderView } from '@merchant-backend/common-components'
import { MARKETING_CENTER_PATH_A } from '@constant'

import store from './store'
import PayModal from './PayModal'
import styles from './style.module.less'

const RadioGroup = Radio.Group

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: {
          payType,
          price,
          title,
          return_url,
          payParams,
          checkParams,
          order_id,
          trade_no
        }
      }
    } = this.props
    if (payType) {
      store.payType = +payType
    }
    store.title = title
    store.order_id = order_id
    store.trade_no = trade_no
    store.payParams = payParams
    store.checkParams = checkParams
    store.return_url = return_url

    if (price) {
      if (price.indexOf('.') > -1) {
        store.price = price
      } else {
        store.price = price + '.00'
      }
    } else {
      store.price = 0
    }
  }
  componentDidMount() {
    store.beforeRouteEnter()
  }
  render() {
    const radioStyle = {
      display: 'block',
      padding: '20px 30px',
      borderBottom: '1px solid #e7e7e7'
    }

    const { payType, price, payStatus, trade_no } = store
    let header = [<a href={MARKETING_CENTER_PATH_A}>服务市场</a>, '收银台']

    return (
      <HeaderView header={header} title="收银台">
        <div className={styles.inner}>
          <div className={styles.infoWrap}>
            <p className={styles.p1}>订单号：{trade_no}</p>
            <p className={styles.p2}>
              支付金额：<span>{price}</span>元
            </p>
          </div>
          <RadioGroup onChange={store.changePayType} value={payType}>
            <Radio style={radioStyle} value={2} disabled={Number(price) <= 0}>
              <img src="http://qnm.hunliji.com/o_1boucjbkf48tqtg1gv2sfshoqb.png" />
              <span className={styles.name}>支付宝支付</span>
              {payType == 2 && (
                <span className={styles.desc}>
                  支付<span>{price}</span>元
                </span>
              )}
            </Radio>
            <Radio style={radioStyle} value={1} disabled={Number(price) <= 0}>
              <img src="http://qnm.hunliji.com/o_1boucjbkf9hi16naqvnmpv1c2kc.png" />
              <span className={styles.name}>微信支付</span>
              {payType == 3 && (
                <span className={styles.desc}>
                  支付<span>{price}</span>元
                </span>
              )}
            </Radio>
          </RadioGroup>
        </div>
        <div className={styles.paybtn}>
          <div onClick={store.toPay}>立即支付</div>
        </div>

        <PayModal money={price} payStatus={payStatus} />
      </HeaderView>
    )
  }
}
